var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8ZM8.44466 3.55566C8.69012 3.55566 8.88911 3.75465 8.88911 4.00011V4.889C8.88911 5.13446 8.69012 5.33344 8.44466 5.33344H7.55577C7.31031 5.33344 7.11133 5.13446 7.11133 4.889V4.00011C7.11133 3.75465 7.31031 3.55566 7.55577 3.55566H8.44466ZM8.44466 6.22217C8.69012 6.22217 8.88911 6.42115 8.88911 6.66661V11.9999C8.88911 12.2454 8.69012 12.4444 8.44466 12.4444H7.55577C7.31031 12.4444 7.11133 12.2454 7.11133 11.9999V6.66661C7.11133 6.42115 7.31031 6.22217 7.55577 6.22217H8.44466Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.da992f20c97147fdd2d3ad72fca98c58.svg";
export { ForwardRef as ReactComponent };